import React from "react";
import { Table, Tooltip } from "antd";
import { inject, observer } from "mobx-react";
import moment from "moment";
import classNames from "classnames";

import Language from "../../../language/language";
import { $const, $util } from "../../../../helper";

const { Column } = Table;

@inject("teamStore", "languageStore")
@observer
export default class ApplicantList extends React.Component {
  update = (record, status) => {
    this.props.teamStore.updateTeamMemberApplication({
      variables: {
        input: {
          id: record.id,
          attributes: {
            teamId: record.teamId,
            memberId: record.id,
            eventRoleId: record.eventRoleId,
            eventPositionId: record.eventPositionId,
            status: status
          }
        }
      }
    });
  };

  render() {
    let applicant = [];
    const lang = this.props.languageStore.lang;
    if (
      !this.props.teamStore.teamInfo.gapplications ||
      !this.props.teamStore.teamInfo.gapplications.nodes
    ) {
      return <div className="team-member-list team-applicant"></div>;
    }
    this.props.teamStore.teamInfo.gapplications.nodes.forEach(item => {
      if (item.status === $const.TEAM_APPLICATION_STATUS.PENDING) {
        applicant.push({
          id: item.id,
          teamId: this.props.teamStore.teamInfo.id,
          avatar: item.member.avatar,
          memberId: item.member.id,
          name: item.member.nickname,
          position: item.eventPosition.position.nameUuidI18n[lang],
          school: item.member.collegeName,
          year:
            item.member.educations &&
            item.member.educations.nodes &&
            item.member.educations.nodes.length > 0 &&
            item.member.educations.nodes[0].beginAt
              ? moment(item.member.educations.nodes[0].beginAt).format("YYYY-MM")
              : "-",
          major:
            item.member.educations &&
            item.member.educations.nodes &&
            item.member.educations.nodes.length > 0
              ? item.member.educations.nodes[0].major
              : "",
          role: item.eventRole.role.nameUuidI18n[lang],
          eventPositionId: item.eventPositionId,
          eventRoleId: item.eventRoleId
        });
      }
    });
    return (
      <div className={classNames("team-member-list team-applicant", this.props.className)}>
        {applicant && applicant.length > 0 ? (
          <Table
            title={() => <Language resource="APPLICANT_LIST" />}
            scroll={{ x: 900 }}
            dataSource={applicant}
            pagination={false}
            rowKey="name"
          >
            <Column
              width={120}
              key="avatar"
              render={(text, record) => (
                <div className="avatar">
                  <img
                    src={
                      $util.getSafePicUrl(record.avatar)
                        ? $util.getSafePicUrl(record.avatar)
                        : $const.DEFAULT_AVATAR
                    }
                    alt={record.name}
                  />
                </div>
              )}
            ></Column>
            <Column
              title={<Language resource="REGISTRATION" />}
              width={120}
              key="name"
              render={(text, record) => {
                return (
                  <div className="name">
                    <Tooltip title={record.name}>
                      <span>{record.name && record.name.slice(0, 4)}</span>
                    </Tooltip>
                  </div>
                );
              }}
            ></Column>
            <Column
              title={<Language resource="POSITION" />}
              width={120}
              key="position"
              render={(text, record) => {
                return (
                  <div className="position">
                    <Tooltip title={record.position}>
                      <span>
                        {record.position && record.position.slice(0, lang === "zh" ? 8 : 16)}
                      </span>
                    </Tooltip>
                  </div>
                );
              }}
            ></Column>
            <Column
              title={<Language resource="DETAIL" />}
              key="action"
              align="center"
              width={160}
              render={(text, record) => {
                return (
                  <div className="operate">
                    {this.props.teamStore.teamInfo.isCaptain ||
                    this.props.teamStore.teamInfo.isSubCaptain ? (
                      <div className="action">
                        <div
                          className="pass spe-link"
                          onClick={this.update.bind(
                            this,
                            record,
                            $const.TEAM_APPLICATION_STATUS.PASS
                          )}
                        >
                          <Language resource="PASS"></Language>
                        </div>
                      </div>
                    ) : null}
                    {this.props.teamStore.teamInfo.isCaptain ||
                    this.props.teamStore.teamInfo.isSubCaptain ? (
                      <div className="action">
                        <div
                          className="spe-link"
                          onClick={this.update.bind(
                            this,
                            record,
                            $const.TEAM_APPLICATION_STATUS.REJECT
                          )}
                        >
                          <Language resource="REJECT"></Language>
                        </div>
                      </div>
                    ) : null}
                  </div>
                );
              }}
            ></Column>
          </Table>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/teamInfo/teamInfoTabs/applicantList.js